var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none",
    viewBox: "0 0 24 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.744 23c6.35 0 11.5-5.149 11.5-11.5S18.094 0 11.744 0C5.392 0 .244 5.149.244 11.5S5.392 23 11.744 23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.244 6v5.5l6 5.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.244 6v5.5l6 5.5"
  })));
};
export default SvgClock;